export default __webpack_public_path__ + "static/media/bluemove.9e42d613.svg";